module.exports = __webpack_public_path__ + "img/qdq.0856cc2b.jpg";